import { html as o, slotted as r } from "@microsoft/fast-element";
import { Toast as s } from "./toast/index.js";
const a = o`
  <div class="control" part="control">
    <slot
      ${r({
  property: "toasts",
  filter: (t) => t instanceof s
})}
    ></slot>
  </div>
`;
export {
  a as toasterTemplate
};
